/**
 * Ignoring this file from test coverage as our test suite isn't
 * currently suited to it.
 *
 * I think this would be best tested in the future by a tool like cypress
 * that runs tests on a live instance of the booking tools app.
 */
/* istanbul ignore file */
export const loadSquareScript = () => {
  const runtimeEnv = process.env.RUNTIME_ENV ?? "development";

  /**
   * Dynamically load the square.js web SDK depending on the environment
   */
  let squareJsSource = "https://sandbox.web.squarecdn.com/v1/square.js";
  if (runtimeEnv === "production") {
    squareJsSource = "https://web.squarecdn.com/v1/square.js";
  }

  const squareScript = document.createElement("script");
  squareScript.src = squareJsSource;
  squareScript.async = true;
  document.body.appendChild(squareScript);
};
